import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MarkdownModule} from 'ngx-markdown';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {ReviewFormMobileComponent} from './reviewForm-mobile.component';
import {VariationsModule} from '../variations/variations.module';
import {RedirectModule} from '../redirect/redirect.module';
import {FormsModule} from '@angular/forms'; 
import {CarouselModule} from 'primeng/carousel';
import {OwlModule} from 'ngx-owl-carousel';
import {GalleryModule} from '@ngx-gallery/core';

const DECLARATIONS = [ReviewFormMobileComponent];

const MODULES = [
    CommonModule,
    MarkdownModule,
    MatIconModule,
    MatButtonModule,
    VariationsModule,
    RedirectModule,
    FormsModule, 
    CarouselModule,
    OwlModule,

];

@NgModule({
    declarations: [...DECLARATIONS],
    imports: [...MODULES, GalleryModule],
    exports: [...DECLARATIONS, ...MODULES]
})
export class ReviewFormMobileModule {
}
